import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const PageWrapper = styled.div`
  padding: 20px 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h4`
  font-size: 22px;
  font-weight: 600;
  color: #2e2e2e;
  margin: 0;
`;

export const AddButton = styled.button`
  background: #2c7be5;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #1a68d1;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d8e0f0;
  border-radius: 6px;
  padding: 0 10px;
  background: #fff;
  height: 36px;
  min-width: 200px;

  svg {
    color: #b0b7c3;
    font-size: 16px;
    flex-shrink: 0;
  }

  input {
    border: none;
    outline: none;
    font-size: 14px;
    color: #2e2e2e;
    background: transparent;
    width: 100%;
    margin-left: 6px;

    &::placeholder {
      color: #b0b7c3;
    }
  }
`;

export const SearchButton = styled.button`
  background: #2c7be5;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 7px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  height: 36px;

  &:hover {
    background: #1a68d1;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DietCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2e2e2e;
  line-height: 1.4;
  text-align: left;
`;

export const CardDescription = styled.div`
  font-size: 13px;
  color: #7b8695;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
  text-align: left;
`;

export const CardDate = styled.div`
  font-size: 12px;
  color: #a0aab4;
  margin-top: 2px;
  text-align: left;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const RecommendButton = styled.button`
  background: #ffffff;
  color: #2c7be5;
  border: 1px solid #2c7be5;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover {
    background: #2c7be5;
    color: #ffffff;
  }
`;

export const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const IconBtn = styled.span`
  cursor: pointer;
  color: #7b8695;
  font-size: 15px;
  display: flex;
  align-items: center;

  &:hover {
    color: #2c7be5;
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
`;

/* ---- Modal Shared Styles ---- */

export const ModalLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #2e2e2e;
  margin-bottom: 6px;
  display: block;
`;

export const ModalInput = styled.input`
  width: 100%;
  border: 1px solid #d8e0f0;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #2e2e2e;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2c7be5;
  }

  &::placeholder {
    color: #b0b7c3;
  }
`;

export const ModalTextarea = styled.textarea`
  width: 100%;
  border: 1px solid #d8e0f0;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #2e2e2e;
  outline: none;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2c7be5;
  }

  &::placeholder {
    color: #b0b7c3;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
`;

export const ErrorText = styled.p`
  font-size: 12px;
  color: #e74c3c;
  margin: 4px 0 0 0;
`;

export const AssignedCount = styled.div`
  font-size: 12px;
  color: #2c7be5;
  margin-top: 4px;
  font-weight: 500;
`;

export const PreviewTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2e2e2e;
  margin-bottom: 8px;
`;

export const PreviewDesc = styled.div`
  font-size: 14px;
  color: #5a6474;
  line-height: 1.6;
`;

export const PreviewModalStyled = styled(Modal)`
  .modal-dialog {
    max-width: 420px !important;
    width: 420px !important;
  }
`;
